// extracted by mini-css-extract-plugin
module.exports = {"premium-folder-icon":"_2rTQh","premiumFolderIcon":"_2rTQh"};